var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionSolidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 11.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10M5.5 8v1h1V8zm1-.822A1.751 1.751 0 0 0 6 3.75a1.75 1.75 0 0 0-1.716 1.406l.98.197A.75.75 0 1 1 6 6.25a.5.5 0 0 0-.5.5v.75h1z"
})));
export { SvgQuestionSolidIcon as ReactComponent };
export default __webpack_public_path__ + "cb11190d37a0dc5dfd5d6b750ff2db96.svg";